import React, { useState } from 'react';

import Modal from 'components/Modal';
import Action from 'components/Misc/Action';
import { Button, Currency } from 'components/Misc/Form';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const INITIAL = {
	amount: ''
};

const Incoming = () => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store payment's data
	const [data, setData] = useState(INITIAL);

	// Use user's creation store
	const onIncomingPayment = useStudentPaymentStore(state => state.onIncomingPayment);

	// Handle payment addition for student
	const onIncoming = () => {
		// Incoming payment to store
		onIncomingPayment(data);

		// Reset data state
		setData(INITIAL);

		// Hide modal
		handleModal();
	};

	// Handle payment data change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<Action
				icon="payments"
				title="Pievienot ienākošo maksājumu"
				subtitle="Maksājuma summa automātiski tiks izdalīta maksājumu plānā"
				onClick={handleModal}
			/>
		
			<Modal title="Pievienot ienākošo maksājumu" visible={modal} handleModal={handleModal}>
				<div className="grid grid-cols-2 gap-4">
					<Currency
						name="amount"
						label="Iemaksātā summa"
						value={data.amount}
						onChange={onChange}
					/>

					<div className="col-span-2 flex justify-end">
						<Button
							icon="check"
							theme="success"
							value="Pievienot"
							onClick={onIncoming}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Incoming;